import { NotSupportedConfig } from '@/models/supported-browsers.model';
import {
    browserName, browserVersion, osName, isMobile,
} from '@/helpers/mobile-device-detect';

export async function detectWebpSupport(): Promise<boolean> {
    return new Promise((resolve) => {
        const image = new Image();
        image.onload = () => resolve(true);
        image.onerror = () => resolve(false);
        // Base64-encoded smallest correct Webp Image
        image.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
        setTimeout(() => resolve(false), 5000);
    });
}

let isWebpSupported = false;
export const getImageExtension = (hasWebpImages: boolean) => (isWebpSupported && hasWebpImages ? '.webp' : '.jpg');
export const getMapImageExtension = (hasWebpImages: boolean) => (isWebpSupported && hasWebpImages ? '.webp' : '.png');

export const updateWebpSupport = (isSupported: boolean) => {
    isWebpSupported = isSupported;
};

export default function checkBrowserSupport() {
    const browser = browserName.toLowerCase();
    const version = Number(browserVersion.split('.')[0]);
    const os = osName.toLowerCase();

    const notSupportedDesktop: NotSupportedConfig = {
        chrome: { below: 55 },
        opera: { below: 42 },
        firefox: { below: 52 },
        safari: { below: 10 },
        edge: { fullySupported: true },
        yandex: { notSupported: true },
        ie: { notSupported: true },
    };

    const notSupportedMobile: NotSupportedConfig = {
        ios: { below: 10 },
        android: { below: 4 },
    };

    const rules = isMobile ? notSupportedMobile[os] : notSupportedDesktop[browser];

    if (!rules) return true;
    if (rules.notSupported) return false;
    if (rules.fullySupported) return true;
    if (Number.isNaN(version)) return true;
    if (rules.below != null && version < rules.below) return false;
    return true;
}
